// カートの内容に応じてモーダルを表示
(async function () {
  window.addEventListener('pageshow', async function (event) {
    const modalElm = $("[data-remodal-id='product-attention-modal']");
    const modalOpen = (targetElement) => {
      // remodal は v1 レイアウトのみでロード(Tier 2-2f で v2-theme.liquid から除去)。v2 の
      // 該当モーダルは v2-pantry-* スニペット(非 remodal)のため、要素/プラグイン不在時は no-op。
      // product-form.js は v1/v2 共有のためのガード(v2 では data 属性が undefined で本来到達しない)。
      if (!targetElement.length || typeof $.fn.remodal !== 'function') {
        return;
      }
      if (targetElement[0] && targetElement[0].style.display === 'none') {
        targetElement[0].style.display = 'inline-block';
      }
      const modal = targetElement.remodal({
        closeOnOutsideClick: false,
      });
      modal.open();
    };
    /**
     *
     * bfcacheから呼ばれた場合（bfcache）
     * reload
     */
    if (event.persisted) {
      window.location.reload();
      return;
    }
    /**
     * バックフォワード時
     * reload
     */
    const entries = performance.getEntriesByType('navigation');
    const isBackForward = entries.some((entry) => entry.type === 'back_forward');
    if (isBackForward) {
      window.location.reload();
      return;
    }
    const hereIsPantryPackPage = modalElm.data('here_is_pantry_pack_page');
    const inCartItemType = modalElm.data('in_cart_item_type');
    if (hereIsPantryPackPage === false && inCartItemType === 'pantry') {
      modalOpen(modalElm);
    }
    const pantrySortSelect = document.querySelector('pantry-sort-select');
    if (pantrySortSelect) {
      pantrySortSelect.sort(pantrySortSelect.querySelector('select').value);
    }
  });
})();
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.isValid;
    this.maxQuantity = 10;
    this.inputValue = Number(this.input.value);
    this.inCartQuantity = Number(this.dataset.in_cart_quantity);
    this.quantityAlertMessageName = this.dataset.quantity_alert_message_name;
    this.id = this.getAttribute('id');
    // 在庫の追跡
    const inventoryManagement = this.dataset.inventory_management;
    if (inventoryManagement) {
      this.isAllowValidation = true;
    } else {
      this.isAllowValidation = false;
    }
    if (this.dataset.is_customer_b2b === 'true') {
      this.maxQuantity = Number(this.dataset.inventory_quantity);
    } else {
      if (this.dataset.max_quantity) {
        this.maxQuantity = Number(this.dataset.max_quantity);
      }
      if (Number(this.dataset.inventory_quantity) < this.maxQuantity) {
        this.maxQuantity = Number(this.dataset.inventory_quantity);
      }
    }

    this.input.addEventListener('change', this.quantityValidate.bind(this));
    this.changeEvent = new Event('change', { bubbles: true });
    this.quantityValidate();
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  quantityValidate() {
    this.isValid = false;
    if (!this.isAllowValidation) {
      return (this.isValid = true);
    }
    this.inputValue = Number(this.input.value);
    if (this.inputValue + this.inCartQuantity <= this.maxQuantity) {
      this.isValid = true;
    }
    this.renderMessage();
    return this.isValid;
  }

  renderMessage() {
    /*
     * 商品数量のバリデーション
     */
    if (!this.isAllowValidation) {
      return;
    }
    const productFormSubmitBtn = document.querySelector(`[data-quantity-input-id="${this.id}"]`);
    const productQuantyAlertMessage = document.querySelector(`quantity-alert-message[data-for="${this.id}"]`);
    // SPのフッターボタンはquantity-input配下にないのでボタンの有効・無効を合わせて制御する
    const productFooterCartButton = document.getElementById('product_footer_cart_button');

    if (this.isValid) {
      if (productQuantyAlertMessage) {
        productQuantyAlertMessage.style.display = 'none';
      }
      if (productFormSubmitBtn) {
        if (productFormSubmitBtn.dataset.isSalesEnd === 'true') {
          productFormSubmitBtn.disabled = true;
          if (productFooterCartButton) {
            productFooterCartButton.disabled = true;
          }
        } else {
          productFormSubmitBtn.disabled = false;
          if (productFooterCartButton) {
            productFooterCartButton.disabled = false;
          }
        }
      }
    } else {
      if (productQuantyAlertMessage) {
        if (this.maxQuantity > 0) {
          productQuantyAlertMessage.style.display = 'flex';
        }
      }
      if (productFormSubmitBtn) {
        productFormSubmitBtn.disabled = true;
      }
      if (productFooterCartButton) {
        productFooterCartButton.disabled = true;
      }
    }
  }
}
customElements.define('quantity-input', QuantityInput);

class QuantityInfo extends HTMLElement {
  constructor() {
    super();
    this.connectedQuantityInputId = this.getAttribute('data-for');
    const quantityInput = document.getElementById(this.connectedQuantityInputId);
    if (quantityInput && quantityInput.isAllowValidation) {
      const maxQuantity = quantityInput.maxQuantity;
      const inCartQuantity = quantityInput.inCartQuantity;
      if (maxQuantity > 0) {
        this.innerHTML = `本商品は一度に${maxQuantity}個まで購入できます<span class="product-quanty-cart__caution-bold">（現在${inCartQuantity}個）</span>`;
      }
    }
  }
}
customElements.define('quantity-info', QuantityInfo);

class QuantityAlertMessage extends HTMLElement {
  constructor() {
    super();
    this.connectedQuantityInputId = this.getAttribute('data-for');
    const quantityInput = document.getElementById(this.connectedQuantityInputId);
    if (quantityInput) {
      this.innerHTML = `<span>${quantityInput.maxQuantity}個までしか購入できません</span>`;
    }
  }
}
customElements.define('quantity-alert-message', QuantityAlertMessage);

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        const hiddenId = this.form.querySelector('[name=id]');
        if (hiddenId) {
          hiddenId.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.product-form__error-message');
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) return;

        try {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');

          const cartData = await this.fetchCartData();
          const formData = this.getFormData();
          const updateData = this.prepareCartUpdateData(cartData, formData);
          if (updateData.existingItemLine) {
            await this.updateCart(updateData);
          } else {
            await this.addToCart(updateData);
          }

          window.location = '/cart';
        } catch (error) {
          this.handleErrorMessage(error.message);
        } finally {
          this.resetSubmitButton(submitButton);
        }
      }

      async fetchCartData() {
        const response = await fetch('/cart.js');
        return response.json();
      }

      getFormData() {
        const form = this.form;
        let quantityInputSectionClass = '.product-variant-cart__section';
        if (screen.width < 750) {
          quantityInputSectionClass = '.product-variant-sp-product-info-footer__section';
        }
        const productVariantCartSection = document.querySelector(quantityInputSectionClass);
        const quantityInput = productVariantCartSection.querySelector('input[name=quantity]');
        const selectedSupport = document.querySelector('select-support');
        const donationInput = document.getElementById('money_donation_per_product');

        return {
          ...JSON.parse(serializeForm(form)),
          quantity: parseInt(quantityInput.value, 10),
          supportGroup: selectedSupport ? selectedSupport.value : '',
          donationAmount: donationInput && !isNaN(donationInput.value) ? parseInt(donationInput.value, 10) : 0,
          expirationDate: form.dataset.expiration_date,
        };
      }

      prepareCartUpdateData(cartData, formData) {
        const existingItem = cartData.items.find((item) => item.variant_id == formData.id);
        const totalQuantity = existingItem ? existingItem.quantity + formData.quantity : formData.quantity;
        const totalDonation = formData.donationAmount * totalQuantity;
        const anyGiftProperties = this.getCurrentLineItemProperties();

        return {
          ...formData,
          existingItemLine: existingItem ? cartData.items.indexOf(existingItem) + 1 : null,
          quantity: totalQuantity,
          properties: {
            ...anyGiftProperties,
            [supportGroupText]: formData.supportGroup,
            [supportAmountText]: totalDonation.toString(),
            賞味期限: formData.expirationDate,
          },
          sections_url: window.location.pathname,
        };
      }
      // https://anyreach.notion.site/e-2b046587eba64420bcd8cdd3cc5cda72
      getCurrentLineItemProperties = () => {
        const properties = {};

        // name属性が「properties[」から始まるinput要素を全件取得
        const propertiesInputs = document.querySelectorAll('input[type=hidden][name^="properties["]');
        if (propertiesInputs) {
          // nameが 'attributes[*]' で、valueが空ではない要素を有効なAttributeとする
          // radioとcheckboxの場合は、チェックされていることも条件とする
          propertiesInputs.forEach((element) => {
            if (element.type === 'radio' || element.type === 'checkbox') {
              if (!element.checked || element.value === '') return;
            }
            if (element.value === '') return;

            const key = element.name.replace(/^properties\[/, '').replace(/\]$/, '');
            // フォームの値を優先する
            properties[key] = element.value;
          });
        }

        return properties;
      };

      async updateCart(updateData) {
        const config = fetchConfig('javascript');
        config.body = JSON.stringify({
          line: updateData.existingItemLine,
          quantity: updateData.quantity,
          properties: updateData.properties,
          sections_url: updateData.sections_url,
        });

        await fetch(`${routes.cart_change_url}`, config);
        this.sendYappliEvent(updateData);
      }

      async addToCart(updateData) {
        const config = fetchConfig('javascript');
        config.body = JSON.stringify(updateData);

        const response = await fetch(`${routes.cart_add_url}`, config);
        const responseData = await response.json();

        if (responseData.status) {
          throw new Error(responseData.description);
        }

        this.sendYappliEvent(updateData);
      }

      sendYappliEvent(data) {
        sendYappliEvent('add_to_cart', {
          price: Shopify.product.price.toString(),
          content_id: `${Shopify.product.id.toString()}-${Shopify.product.variant.id.toString()}`,
          content_type: Shopify.product.type,
          currency: 'JPY',
          quantity: data.quantity.toString(),
        });
      }

      resetSubmitButton(submitButton) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');

        const spinner = document.querySelector('.loading-overlay__spinner');
        if (spinner) {
          spinner.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (!this.errorMessageWrapper || !this.errorMessage) return;

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          const noticeElements = document.getElementsByClassName('product-form-cart-wrap__notice');
          for (let element of noticeElements) {
            element.style.marginTop = '40px';
          }
        }
      }
    },
  );
}

if (!customElements.get('select-support')) {
  customElements.define(
    'select-support',
    class SelectSupport extends HTMLElement {
      connectedCallback() {
        const selectBox = this.querySelector('select');
        this.value = selectBox.value;
        selectBox.addEventListener('change', (event) => {
          /**
           * select-supportが複数存在するための処理
           * どれか一つの選択で全てselect-supportのvalue値を更新
           * select-supportが一つになった際不要
           */
          const selectSupports = document.querySelectorAll('select-support');
          for (const selectBox of selectSupports) {
            selectBox.value = event.target.value;
          }
        });
      }
    },
  );
}

// pantry選択合計金額
if (!customElements.get('pantry-info')) {
  customElements.define(
    'pantry-info',
    class pantryInfo extends HTMLElement {
      connectedCallback() {
        this.pantryInfoDefault = this.querySelector("[data-name='pantry-info-default']");
        this.pantryInfoAmountClear = this.querySelector("[data-name='pantry-info-amount-clear']");
        this.pantryInfoWeightMax = this.querySelector("[data-name='pantry-info-weight-max']");
        this.pantryInfoWeightOver = this.querySelector("[data-name='pantry-info-weight-over']");
        this.pantryInfoSoldOut = this.querySelector("[data-name='pantry-info-soldout']");
        this.pantryInfoDefault.style.display = 'none';
        this.pantryInfoAmountClear.style.display = 'none';
        this.pantryInfoWeightMax.style.display = 'none';
        this.pantryInfoWeightOver.style.display = 'none';
        this.pantryInfoSoldOut.style.display = 'none';
      }

      render(type) {
        this.pantryInfoDefault.style.display = type === 'default' ? 'block' : 'none';
        this.pantryInfoAmountClear.style.display = type === 'amountClear' ? 'block' : 'none';
        this.pantryInfoWeightMax.style.display = type === 'weightMax' ? 'block' : 'none';
        this.pantryInfoWeightOver.style.display = type === 'weightOrver' ? 'block' : 'none';
        this.pantryInfoSoldOut.style.display = type === 'soldOut' ? 'block' : 'none';
      }
    },
  );
}

if (!customElements.get('pantry-product-quantity')) {
  customElements.define(
    'pantry-product-quantity',
    class PantryProductQuantity extends HTMLElement {
      constructor() {
        super();
        this.boundHandlePlusBtn = this.handlePlusBtn.bind(this);
        this.boundHandleMinusBtn = this.handleMinusBtn.bind(this);
        this.boundHandleQuantityInput = this.handleQuantityInput.bind(this);
      }

      connectedCallback() {
        this.variantId = Number(this.dataset.product_variant_id);
        this.weightG = Number(this.dataset.product_weight_g);
        this.plusBtn = this.querySelector(`[data-name="pantry-product-quantity-plus"]`);
        this.minusBtn = this.querySelector(`[data-name="pantry-product-quantity-minus"]`);
        this.quantityInput = this.querySelector(`[data-name="pantry-product-quantity-input"]`);
        this.quantityInput.value = '0';
        this.pantryProductQuantityAlertMessage = this.querySelector(
          `[data-name="pantry-product-quantity-alert-message"]`,
        );
        this.expirationOn = this.dataset.expiration_on;
        this.productVariantPrice = Number(this.dataset.product_variant_price);
        if (Number(this.dataset.parent_product_inventory_quantity) <= 0) {
          this.plusBtn.disabled = true;
          this.minusBtn.disabled = true;
          this.quantityInput.disabled = true;
          return;
        }

        if (this.querySelector(`[data-name="max-quantity-info"]`)) {
          this.querySelector(`[data-name="max-quantity-info"]`).style.display = 'block';
        }

        this.plusBtn.removeEventListener('click', this.boundHandlePlusBtn);
        this.minusBtn.removeEventListener('click', this.boundHandleMinusBtn);
        this.quantityInput.removeEventListener('change', this.boundHandleQuantityInput);

        this.plusBtn.addEventListener('click', this.boundHandlePlusBtn);
        this.minusBtn.addEventListener('click', this.boundHandleMinusBtn);
        this.quantityInput.addEventListener('change', this.boundHandleQuantityInput);
      }

      isOverStockLimit() {
        const productInventoryQuantity = Number(this.dataset.product_inventory_quantity);
        if (productInventoryQuantity >= Number(this.quantityInput.value)) {
          return false;
        }
        return true;
      }

      isOverMaxQuantityLimit() {
        if (!this.dataset.max_quantity || Number(this.dataset.max_quantity) >= Number(this.quantityInput.value)) {
          return false;
        }
        return true;
      }

      toggleMaxQuantityInfoMessage(isOver = false) {
        if (this.querySelector(`[data-name="max-quantity-info"]`)) {
          this.querySelector(`[data-name="max-quantity-info"]`).style.display = isOver ? 'none' : 'block';
          this.querySelector(`[data-name="max-quantity-info-alert"]`).style.display = isOver ? 'flex' : 'none';
        }
      }

      handlePlusBtn() {
        this.quantityInput.value = Number(this.quantityInput.value) + 1;
        const event = new Event('change');
        this.quantityInput.dispatchEvent(event);
      }

      handleMinusBtn() {
        if (Number(this.quantityInput.value) > 0) {
          this.quantityInput.value = Number(this.quantityInput.value) - 1;
        } else {
          this.quantityInput.value = 0;
        }
        const event = new Event('change');
        this.quantityInput.dispatchEvent(event);
      }

      handleQuantityInput() {
        const pantryProducts = document.querySelector('pantry-products');
        let quantity = 0;
        if (Number(this.quantityInput.value) > 0) {
          this.quantityInput.value = Number(this.quantityInput.value);
          quantity = Number(this.quantityInput.value);
        } else {
          this.quantityInput.value = 0;
          quantity = 0;
        }
        // idが既に存在するか確認
        const index = pantryProducts.selectedPantries.findIndex((pantry) => pantry.id === this.variantId);
        // idが存在すれば更新
        if (index !== -1) {
          pantryProducts.selectedPantries[index].quantity = quantity;
          // weight更新
          pantryProducts.selectedPantries[index].weightG =
            this.weightG * pantryProducts.selectedPantries[index].quantity;
        }
        // idが存在しないが、数量が0でなければ追加
        else if (index === -1 && quantity !== 0) {
          pantryProducts.selectedPantries.push({
            id: this.variantId,
            quantity: quantity,
            productVariantPrice: this.productVariantPrice,
            title: this.dataset.product_title,
            sku: this.dataset.sku,
            weightG: this.weightG * quantity,
            expirationOn: this.expirationOn,
          });
        }
        pantryProducts.updateProductQuantities();
        pantryProducts.updateDisplayAndValidation();
      }
    },
  );
}

// remainingRequiredAmount
// 残金額
if (!customElements.get('remaining-required-amount')) {
  customElements.define(
    'remaining-required-amount',
    class remainingRequiredAmount extends HTMLElement {
      connectedCallback() {
        this.minimumPrice = Number(this.dataset.minimum_price);
        this.innerText = Number(this.innerText).toLocaleString();
      }

      update(price) {
        const remainingRequiredAmount = this.minimumPrice - Number(price);
        if (remainingRequiredAmount >= 0) {
          this.innerText = remainingRequiredAmount.toLocaleString();
        } else {
          this.innerText = 0;
        }
      }
    },
  );
}
// pantry選択合計金額
if (!customElements.get('pantry-selected-total-amount')) {
  customElements.define(
    'pantry-selected-total-amount',
    class pantrySelectedTotalAmount extends HTMLElement {
      connectedCallback() {
        this.innerText = 0;
      }

      update(totalAmount) {
        this.innerText = totalAmount.toLocaleString();
      }
    },
  );
}

// pantry選択合計重量
if (!customElements.get('pantry-selected-total-weight')) {
  customElements.define(
    'pantry-selected-total-weight',
    class pantrySelectedTotalWeight extends HTMLElement {
      connectedCallback() {
        this.innerHTML = '0<span>g</span>';
      }

      update(totalWeightG) {
        // g表示
        if (Number(totalWeightG) < 1000) {
          this.innerHTML = `${String(totalWeightG)}<span>g</span>`;
        } else {
          // Kg表示
          this.innerHTML = `${String(totalWeightG / 1000)}<span>kg</span>`;
        }
      }
    },
  );
}

if (!customElements.get('pantry-selected-total-quantity')) {
  customElements.define(
    'pantry-selected-total-quantity',
    class pantrySelectedTotalQuantity extends HTMLElement {
      connectedCallback() {
        this.innerText = 0;
      }

      update(totalQuantity) {
        this.innerText = totalQuantity;
      }
    },
  );
}

if (!customElements.get('product-pantry-fixed')) {
  customElements.define(
    'product-pantry-fixed',
    class productPantryFixed extends HTMLElement {
      connectedCallback() {
        this.style.opacity = '1';
        this.ticking = false;
        this.scrollListener();
      }

      update() {
        const bottomBtnContainer = document.querySelector('[data-name="bottom-btn-container"]');
        if (bottomBtnContainer) {
          const targetPosition = bottomBtnContainer.getBoundingClientRect().top + window.pageYOffset;
          const elementPosition = this.getBoundingClientRect().top + window.pageYOffset;
          const mediaQueryList = window.matchMedia('(max-width: 750px)');
          if (mediaQueryList.matches && elementPosition >= targetPosition) {
            this.style.opacity = '0';
          } else {
            this.style.opacity = '1';
          }
          this.ticking = false;
        }
      }

      requestTick() {
        if (!this.ticking) {
          requestAnimationFrame(() => this.update());
          this.ticking = true;
        }
      }

      scrollListener() {
        window.addEventListener('scroll', () => this.requestTick());
      }
    },
  );
}

if (!customElements.get('product-pantry-cart-button-wrap')) {
  customElements.define(
    'product-pantry-cart-button-wrap',
    class ProductForm extends HTMLElement {
      connectedCallback() {
        // 親商品の在庫がない場合、return
        if (Number(this.dataset.product_inventory_quantity) <= 0) {
          return;
        }
        const pantryProducts = document.querySelector('pantry-products');
        this.button = this.querySelector('button');
        this.button.addEventListener('click', async (event) => {
          const productPantryCartButtonWraps = document.querySelectorAll('product-pantry-cart-button-wrap');
          for (const productPantryCartButtonWrap of productPantryCartButtonWraps) {
            productPantryCartButtonWrap.button.disabled = true;
          }
          if (pantryProducts.isDuplicatePantryItemInCart === 'true') {
            this.addCart(true);
          } else {
            this.addCart();
          }
        });
        this.productVariantId = this.dataset.product_variant_id;
      }

      createUniqueStr() {
        return Date.now().toString(36);
      }

      async handleProductSoldOut() {
        // 同ページ取得
        const response = await fetch(window.location.pathname);
        const newHtmlText = await response.text();
        const parser = new DOMParser();
        // DOM差し替え
        const newHtmlDocument = parser.parseFromString(newHtmlText, 'text/html');
        const pantryProductsElement = document.querySelector('pantry-products');
        // recommendDom差し替え
        document.querySelector(`[data-name="pantry-contents-recommend"]`).innerHTML = newHtmlDocument.querySelector(
          `[data-name="pantry-contents-recommend"]`,
        ).innerHTML;
        // 商品リストDom差し替え
        pantryProductsElement.innerHTML = newHtmlDocument.querySelector('pantry-products').innerHTML;
        const pantryProductQuantities = document.querySelectorAll('pantry-product-quantity');
        const newProductPantryCartButtonWrap = newHtmlDocument.querySelector('product-pantry-cart-button-wrap');
        // 親パントリーが在庫切れの場合ボタン差し替え
        if (newProductPantryCartButtonWrap.dataset.product_inventory_quantity <= 0) {
          const productPantryCartButtonWraps = document.querySelectorAll('product-pantry-cart-button-wrap');
          for (const productPantryCartButtonWrap of productPantryCartButtonWraps) {
            productPantryCartButtonWrap.innerHTML = newProductPantryCartButtonWrap.innerHTML;
          }
        }

        // remodalを初期化
        $('[data-remodal-id^="pantry-product-modal-id-"]').each(function () {
          $(this).remodal();
        });

        const soldOutIds = [];
        // 差し替えたHTMLに現在の選択リストを反映
        for (const item of pantryProductsElement.selectedPantries) {
          // pantry-product-quantityのvalue値に反映
          const selectedPantryProductQuantities = Array.from(pantryProductQuantities).filter((element) => {
            if (element.variantId === item.id) {
              return element;
            }
          });
          if (selectedPantryProductQuantities.length <= 0) {
            soldOutIds.push(item.id);
          }
        }
        // 在庫0商品を選択したリストから削除
        const updatedPantryProducts = pantryProductsElement.removeSelectedPantryItems(soldOutIds);
        updatedPantryProducts.updateProductQuantities();
        newProductPantryCartButtonWrap.dataset.product_inventory_quantity <= 0
          ? updatedPantryProducts.updateDisplayAndValidation(true)
          : updatedPantryProducts.updateDisplayAndValidation();
        const pantryInfos = document.querySelectorAll('pantry-info');
        for (const pantryInfo of pantryInfos) {
          pantryInfo.render('soldOut');
        }
      }

      clearCart() {
        return fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });
      }

      async addCart(isUpdate = false) {
        if (isUpdate) {
          const clearResponse = await this.clearCart();
          if (!clearResponse.ok) {
            return;
          }
        }
        const body = this.createBody();
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        });
        if (response.ok) {
          window.location.href = '/cart';
        } else if (response.status === 422) {
          if (!isUpdate) {
            const clearResponse = await this.clearCart();
            if (!clearResponse.ok) {
              for (const productPantryCartButtonWrap of productPantryCartButtonWraps) {
                productPantryCartButtonWrap.button.disabled = false;
              }
              return;
            }
          }
          await this.handleProductSoldOut();
        } else {
          for (const productPantryCartButtonWrap of productPantryCartButtonWraps) {
            productPantryCartButtonWrap.button.disabled = false;
          }
        }
      }

      createBody() {
        const pantryProducts = document.querySelector('pantry-products');
        const selectSupportValue = document.querySelector('select-support').value;
        const pantryKey = this.createUniqueStr();
        const body = {
          items: [
            {
              id: this.productVariantId,
              quantity: 1,
              properties: {
                [supportGroupText]: selectSupportValue,
                [supportAmountText]: pantryProducts.donationMoney(),
                // 親用のユニーク値
                _pantryKey: pantryKey,
                _パントリータイプ: 'パントリーケース',
              },
            },
          ],
        };
        for (const product of pantryProducts.selectedPantries) {
          body.items.push({
            id: product.id,
            quantity: product.quantity,
            properties: {
              // 親のユニーク値（親との紐付け）
              _pantryKey: pantryKey,
              _パントリータイプ: 'パントリーピース',
              賞味期限: product.expirationOn,
            },
          });
        }
        return body;
      }
    },
  );
}

if (!customElements.get('pantry-products-recommend')) {
  customElements.define(
    'pantry-products-recommend',
    class pantryProductsRecommend extends HTMLElement {
      connectedCallback() {
        this.style.display = 'block';
        const mySwiper = new Swiper('.pantry-recommend-swiper-container', {
          loop: true,
          slidesPerView: 2,
          spaceBetween: 10,
          autoplay: {
            delay: 3000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
          },
          navigation: {
            nextEl: '.pantry-recommend-swiper-button-next',
            prevEl: '.pantry-recommend-swiper-button-prev',
          },
          on: {
            init: this.checkSlidesCount,
          },
        });
      }

      checkSlidesCount() {
        const actualSlidesCount = this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
        const nextButton = this.el.querySelector('.pantry-recommend-swiper-button-next');
        const prevButton = this.el.querySelector('.pantry-recommend-swiper-button-prev');
        if (actualSlidesCount <= 2) {
          this.allowTouchMove = false;
          this.params.autoplay = {};
          nextButton.style.display = 'none';
          prevButton.style.display = 'none';
          if (actualSlidesCount === 1) {
            this.params.slidesPerView = 1;
          }
          this.update();
        }
      }
    },
  );
}

if (!customElements.get('pantry-filter')) {
  customElements.define(
    'pantry-filter',
    class pantryFilter extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll(`[data-name="pantry-filter-modal-label"]`).forEach((item) => {
          if (item.dataset.is_active === 'false') {
            item.querySelector('input').disabled = true;
            item.querySelector('span').classList.add('pantry-filter-modal-checkbox-disabled');
          }
        });
        // checkbox
        const pantryFilterModalCheckboxes = this.querySelectorAll('[data-name="pantry-filter-modal-checkbox"]');
        for (const item of pantryFilterModalCheckboxes) {
          item.addEventListener('change', function () {
            if (this.value === '全て') {
              for (const item of pantryFilterModalCheckboxes) {
                // on 全てを選択した場合、全て以外checkedが外れる
                if (this.checked && item.value !== this.value) {
                  item.checked = false;
                  // off　全てを外した場合、全て以外のcheckboxがcheckedになる
                } else if (!this.checked && item.value !== this.value && !item.disabled) {
                  item.checked = true;
                }
              }
            } else {
              // 全てを外す
              document.querySelector('input[data-name="pantry-filter-modal-checkbox"][value="全て"]').checked = false;
            }
          });
        }
        this.querySelector('button').addEventListener('click', function () {
          const pantryFilterModalCheckboxes = document.querySelectorAll('[data-name="pantry-filter-modal-checkbox"]');
          for (const item of pantryFilterModalCheckboxes) {
            if (document.querySelector(`[data-pantry-product-type="${item.value}"]`)) {
              document.querySelector(`[data-pantry-product-type="${item.value}"]`).style.display = item.checked
                ? 'flex'
                : 'none';
            }
          }
          // modal閉じる
          // remodal は v1 レイアウトのみでロード(Tier 2-2f で v2-theme.liquid から除去)。この
          // ハンドラは <pantry-filter>(v1 の product-variant-pantry.liquid)接続時のみ束縛され
          // v2 では到達しないが、共有ファイルの防御として remodal 不在時はスキップする。
          if (typeof $.remodal !== 'undefined' && $.remodal.lookup) {
            const modal = $.remodal.lookup[$('[data-remodal-id="pantry-filter-modal"]').data('remodal')];
            modal.close();
          }
        });
      }
    },
  );
}

if (!customElements.get('pantry-sort-select')) {
  customElements.define(
    'pantry-sort-select',
    class pantrySortSelect extends HTMLElement {
      connectedCallback() {
        const self = this;
        this.querySelector('select').addEventListener('change', function () {
          self.sort(this.value);
        });
      }

      getValueFromAttribute = (element, value) => {
        if (value === 'expiration' || value === 'published_at') {
          return new Date(element.getAttribute(`data-${value}`)).getTime();
        }
        return parseInt(element.getAttribute(`data-${value}`), 10);
      };

      sort(value) {
        // 昇順 false降順
        const isAscending = value === 'index' || value === 'expiration' || value === 'price';
        const pantryProductTypeSections = [...document.querySelectorAll(`[data-name="pantry-product-type-section"]`)];
        for (const pantryProductTypeSection of pantryProductTypeSections) {
          const pantryProductTypeSectionChildList = [...pantryProductTypeSection.children];
          pantryProductTypeSectionChildList.sort((pantryProductElementA, pantryProductElementB) => {
            // expiration（賞味期限）の場合は、UNIXタイムスタンプ（エポックタイム）を使用
            const pantryProductA = this.getValueFromAttribute(pantryProductElementA, value);
            const pantryProductB = this.getValueFromAttribute(pantryProductElementB, value);
            const diff = isAscending ? pantryProductA - pantryProductB : pantryProductB - pantryProductA;
            if (diff) {
              return diff;
            }
            // AとBの値が同じ場合、product_idでソート
            return (
              parseInt(pantryProductElementB.dataset.product_id, 10) -
              parseInt(pantryProductElementA.dataset.product_id, 10)
            );
          });
          pantryProductTypeSection.innerHTML = '';
          pantryProductTypeSectionChildList.forEach((element) => {
            pantryProductTypeSection.appendChild(element);
          });
        }
        document.querySelector('pantry-products').updateProductQuantities();
        document.querySelector('pantry-products').updateDisplayAndValidation();
      }
    },
  );
}

if (!customElements.get('pantry-products')) {
  customElements.define(
    'pantry-products',
    class PantryList extends HTMLElement {
      async connectedCallback() {
        this.selectedPantries = [];
        this.minimumPrice = Number(this.dataset.minimum_price);
        this.maxBoxWeightG = Number(this.dataset.max_box_weight_g);
        this.isDuplicatePantryItemInCart = this.dataset.is_duplicate_pantry_item_in_cart;
        const cart = JSON.parse(this.dataset.cart);
        if (this.isDuplicatePantryItemInCart === 'true') {
          this.updateSelectedValue(cart);
        } else {
          const pantryInfos = document.querySelectorAll('pantry-info');
          for (const pantryInfo of pantryInfos) {
            pantryInfo.render('default');
          }
        }
      }

      updateSelectedValue(cart) {
        const pantryProductQuantities = document.querySelectorAll('pantry-product-quantity');
        let cartPantryItems = [];
        cartPantryItems = cart.items.filter(
          (item) => item.properties && item.properties._パントリータイプ === 'パントリーピース',
        );
        for (const item of cartPantryItems) {
          this.selectedPantries.push({
            id: item.variant_id,
            quantity: item.quantity,
            productVariantPrice: this.convertPrice(item.price),
            title: item.title,
            sku: item.sku,
            weightG: item.grams * item.quantity,
            expirationOn: item.properties.賞味期限,
          });
        }
        // quantity適用
        this.updateProductQuantities();
        Number(this.dataset.product_inventory_quantity) <= 0
          ? this.updateDisplayAndValidation(true)
          : this.updateDisplayAndValidation();
      }

      updateProductQuantities() {
        for (const selectedProduct of this.selectedPantries) {
          const pantryProductQuantities = document.querySelectorAll(
            `[data-product_variant_id="${selectedProduct.id}"]`,
          );
          Array.from(pantryProductQuantities).map((node) => {
            node.quantityInput.value = selectedProduct.quantity;
          });
        }
      }

      updateDisplayAndValidation(isParentPantryProductSoldOut = false) {
        const productPantryCartButtonWraps = document.querySelectorAll('product-pantry-cart-button-wrap');
        const pantryInfos = document.querySelectorAll('pantry-info');
        const allQuantityInput = document.querySelectorAll(`[data-name="pantry-product-quantity-input"]`);
        const pantryProductQuantities = document.querySelectorAll('pantry-product-quantity');
        const remainingRequiredAmounts = document.querySelectorAll('remaining-required-amount');
        for (const remainingRequiredAmount of remainingRequiredAmounts) {
          remainingRequiredAmount.update(this.grandTotalPrice());
        }
        // 金額
        const pantrySelectedTotalAmounts = document.querySelectorAll('pantry-selected-total-amount');
        for (const pantrySelectedTotalAmount of pantrySelectedTotalAmounts) {
          pantrySelectedTotalAmount.update(this.grandTotalPrice());
        }
        // 数量
        const pantrySelectedTotalQuantities = document.querySelectorAll('pantry-selected-total-quantity');
        for (const pantrySelectedTotalQuantity of pantrySelectedTotalQuantities) {
          pantrySelectedTotalQuantity.update(this.totalQuantity());
        }
        // 重さ
        const pantrySelectedTotalWeights = document.querySelectorAll('pantry-selected-total-weight');
        for (const pantrySelectedTotalWeight of pantrySelectedTotalWeights) {
          pantrySelectedTotalWeight.update(this.totalWeightG());
        }
        // 支援金額
        const donationMoneyes = document.querySelectorAll("[data-name='donation_money']");
        for (const donationMoney of donationMoneyes) {
          donationMoney.innerHTML = `${String(this.donationMoney().toLocaleString())}<span>円</span>`;
        }
        for (const item of pantryProductQuantities) {
          if (item.dataset.prevent_adding_pantry_cart_item === 'true') {
            item.minusBtn.disabled = true;
            item.plusBtn.disabled = true;
            continue;
          }
          // 箱の残重量を超えている、在庫数を超過している、親パントリー商品の在庫切れの場合、子商品のプラスボタンを非活性
          if (
            item.weightG > this.remainingWeightCapacityOfTheBox() ||
            item.isOverStockLimit() ||
            item.isOverMaxQuantityLimit() ||
            isParentPantryProductSoldOut
          ) {
            item.plusBtn.disabled = true;
          } else {
            item.plusBtn.disabled = false;
          }

          if (isParentPantryProductSoldOut) {
            item.minusBtn.disabled = true;
          }

          // 在庫数アラートテキスト表示
          if (item.isOverStockLimit()) {
            item.pantryProductQuantityAlertMessage.style.display = 'block';
          } else {
            item.pantryProductQuantityAlertMessage.style.display = 'none';
          }

          if (item.isOverMaxQuantityLimit()) {
            item.toggleMaxQuantityInfoMessage(true);
          } else {
            item.toggleMaxQuantityInfoMessage();
          }

          // class付与
          if (Number(item.quantityInput.value) > 0) {
            item.quantityInput.classList.add('pantry-quantity-input-active');
          } else {
            item.quantityInput.classList.remove('pantry-quantity-input-active');
          }
        }

        if (this.isOverMaxBoxWeight()) {
          // 重量の超過
          for (const pantryInfo of pantryInfos) {
            pantryInfo.render('weightOrver');
          }
          for (const productPantryCartButtonWrap of productPantryCartButtonWraps) {
            productPantryCartButtonWrap.button.disabled = true;
          }
          return;
        }

        if (this.isBelowMinimumPrice()) {
          // 金額未達成
          for (const pantryInfo of pantryInfos) {
            pantryInfo.render('default');
          }
          for (const productPantryCartButtonWrap of productPantryCartButtonWraps) {
            productPantryCartButtonWrap.button.disabled = true;
          }
          for (const quantityInput of allQuantityInput) {
            quantityInput.disabled = false;
          }
          return;
        }

        if (this.isOverStockLimit() || this.isOverMaxQuantityLimit()) {
          // 在庫数以上選択、最大購入数量の超過
          for (const productPantryCartButtonWrap of productPantryCartButtonWraps) {
            productPantryCartButtonWrap.button.disabled = true;
          }
          return;
        }

        if (isParentPantryProductSoldOut) {
          // 親パントリー商品在庫切れ
          return;
        } // 全てクリア

        for (const productPantryCartButtonWrap of productPantryCartButtonWraps) {
          productPantryCartButtonWrap.button.disabled = false;
        }

        // 箱の残重量以下の商品がない
        if (this.isNoProductsThatCanBePutInTheBox()) {
          // ボックスいっぱいの表示
          for (const pantryInfo of pantryInfos) {
            pantryInfo.render('weightMax');
          }
        } else {
          for (const pantryInfo of pantryInfos) {
            pantryInfo.render('amountClear');
          }
        }
      }

      convertPrice(price) {
        // 価格を整数に変換（切り捨て）してから100で割る
        return Math.floor(Number(price)) / 100;
      }

      isOverStockLimit() {
        const pantryProductQuantities = document.querySelectorAll('pantry-product-quantity');
        for (const pantryProductQuantity of pantryProductQuantities) {
          if (pantryProductQuantity.isOverStockLimit()) {
            return true;
          }
        }
        return false;
      }

      isOverMaxQuantityLimit() {
        const pantryProductQuantities = document.querySelectorAll('pantry-product-quantity');
        for (const pantryProductQuantity of pantryProductQuantities) {
          if (pantryProductQuantity.isOverMaxQuantityLimit()) {
            return true;
          }
        }
        return false;
      }

      isBelowMinimumPrice() {
        // 最低金額
        if (this.minimumPrice > this.grandTotalPrice()) {
          return true;
        }
        return false;
      }

      isNoProductsThatCanBePutInTheBox() {
        const pantryProductQuantities = document.querySelectorAll('pantry-product-quantity');
        for (const item of pantryProductQuantities) {
          if (item.weightG < this.remainingWeightCapacityOfTheBox()) {
            return false;
          }
        }
        return true;
      }

      isOverMaxBoxWeight() {
        if (this.maxBoxWeightG < this.totalWeightG()) {
          return true;
        }
        return false;
      }

      // 残りの箱に入れられる重さ
      remainingWeightCapacityOfTheBox() {
        return this.maxBoxWeightG - this.totalWeightG();
      }

      grandTotalPrice() {
        let grandTotalPrice = 0;
        for (const pantry of this.selectedPantries) {
          const subTotal = pantry.quantity * pantry.productVariantPrice;
          grandTotalPrice += subTotal;
        }
        return grandTotalPrice;
      }

      totalQuantity() {
        let totalQuantity = 0;
        for (const pantry of this.selectedPantries) {
          totalQuantity += pantry.quantity;
        }
        return totalQuantity;
      }

      totalWeightG() {
        let totalWeightG = 0;
        for (const pantry of this.selectedPantries) {
          totalWeightG += pantry.weightG;
        }
        return totalWeightG;
      }

      // 支援金額
      donationMoney() {
        // 支援金額割合（1%）
        const donationMoneyRatio = 1;
        return Math.floor((this.grandTotalPrice() * donationMoneyRatio) / 100);
      }

      // selectedPantriesのリストからid指定で削除
      removeSelectedPantryItems(soldOutIds) {
        for (const id of soldOutIds) {
          const index = this.selectedPantries.findIndex((item) => item.id === id);
          if (index !== -1) {
            this.selectedPantries.splice(index, 1);
          }
        }
        return this;
      }
    },
  );
}
